let initModeratorCommands = (context) => {
    class Command{
        constructor(context, type, callbackFunction) {
            this.context = context;
            this.type = type;
            this.callbackFunction = callbackFunction;
            this.registerCommand();
        }

        // Execute Callbackfunction, when localUserID is in targetIDs
        registerCommand(){
            console.log("Register "+this.type)
            this.context.session.on("signal:"+this.type,(event) => {
                let data = JSON.parse(event.data);
                
                // Block callback
                if(data.sourceUserID != this.context.localUserID){
                    if(data.includeUserIDs){
                        if(data.includeUserIDs.find(id => id == this.context.localUserID) != undefined){
                            // console.log("Recieved "+this.type)
                            // console.log("")
                            this.callbackFunction(data);
                        }         
                    }else{
                        // console.log("Recieved "+this.type)
                        // console.log("")
                        this.callbackFunction(data);
                    }
                }

            });
        }

        // Send data as Json to all Users
        executeCommand(data){
            // console.log("Sending "+this.type)
            // console.log("")
            const signalData = {
                type: this.type,
                data: JSON.stringify(data),
            };
            this.context.session.signal(signalData, function (error) {
                if (error) 
                    console.log(['signal error (', error.code, '): ', error.message].join(''));
            });
        }
    }

    // Sends Camera Rotation and fov to User
    class CommandSendModeratorPosition extends Command{
        constructor(context) {
            super(context,"CommandSendModeratorPosition", (data) => {
                let camera;
                
                if(data.type == "Default"){
                    camera = window.scene.activeCamera;
                    camera.fov = data.fov;
                    if(context.currentSituationID != data.currentSituationID)
                        context.handleGotoSituationTransition({situationID: data.currentSituationID, comesFromModerator: true})
                }

                if(data.type == "3DViewer"){
                    camera = window.scene3DViewer.activeCamera;
                    camera.radius = data.radius;
                }

                camera.alpha = data.alpha;
                camera.beta = data.beta;
                camera.target.x = data.target._x;
                camera.target.y = data.target._y;
                camera.target.z = data.target._z;
            });
        }
    }

    // Blocks Camera Control from User
    class CommandChangeUserControl extends Command{
        constructor(context) {
            super(context,"CommandChangeUserControl", (data) => {
                context.setFollowModeratorMode(!data.userControl);
            });
        }
    }

    // Mute User
    class CommandMute extends Command{
        constructor(context) {
            super(context,"CommandMuteUsers", () => {
                context.publisher.publishAudio(false);
                context.$store.commit("setAudioOn", false);
            });
        }
    }

    // Stop Video from User
    class CommandStopVideo extends Command{
        constructor(context) {
            super(context,"CommandStopVideo", () => {
                context.publisher.publishVideo(false);
                context.$store.commit("setVideoOn", false);
            });
        }
    }

    // Send Generic Event to User (Event can be implemented anywhere)
    class CommandSendEvent extends Command{
        constructor(context) {
            super(context,"CommandSendEvent", (data) => {
                console.log("Recieved "+data.eventName)
                window.dispatchEvent(new CustomEvent(data.eventName,{detail: data}));
            });
        }
    }


    console.log("Initialize Moderator Commands");
    let commandSendModeratorPositionInstance = new CommandSendModeratorPosition(context);
    let commandChangeUserControlInstance = new CommandChangeUserControl(context);
    let commandMuteInstance = new CommandMute(context);
    let commandStopVideoInstance = new CommandStopVideo(context);
    let commandSendEventInstance = new CommandSendEvent(context);

    window.addEventListener("sendCommand", (e) => {
        let data = e.detail.data;
        data.sourceUserID = e.detail.sourceUserID;

        if(e.detail.type === "CommandSendModeratorPosition")
            commandSendModeratorPositionInstance.executeCommand(data)
        if(e.detail.type === "CommandChangeUserControl")
            commandChangeUserControlInstance.executeCommand(data) 
        if(e.detail.type === "CommandMute")
            commandMuteInstance.executeCommand(data)
        if(e.detail.type === "CommandStopVideo")
            commandStopVideoInstance.executeCommand(data)
        if(e.detail.type === "CommandSendEvent")
            commandSendEventInstance.executeCommand(data)
    });
}

export default initModeratorCommands